/*
Toric calculator
Javascript version, ported from Flex
TJS'13
*/

var spinner;
var target;
var bvdCalc;
var prevRatio = 0;

var app = app || {};

app.toric = {

	init: function()
	{
		
		/* setup the tabs */
		$( "#tabs" ).tabs();
		
		/* populate the dropdowns */
		
		var minSphere = -20
		var maxSphere = 20
		var minCyl = -10
		var maxCyl = 0
		var minAxis = 1
		var maxAxis = 180
		
		for (i = minSphere; i <= maxSphere; i += 0.25)
		{
			var val = (i>0)?"+"+String(i.toFixed(2)):String(i.toFixed(2));
			var opt = "<option value='"+i+"'>"+val+"</option>"
			if(i==0) opt = "<option selected value='"+i+"'>"+val+"</option>";
			$('#userSetSpherical').append(opt);
			$('#userSetSpherical-BVD').append(opt);
		}

		for (i=minCyl;i<=maxCyl;i+=0.25)
		{
			var val = (i>0)?"+"+String(i.toFixed(2)):String(i.toFixed(2));
			var opt = "<option value='"+i+"'>"+val+"</option>"
			if(i==0) opt = "<option selected value='"+i+"'>"+val+"</option>";
			$('#userSetCylindrical').append(opt);
			$('#userSetCylindrical-BVD').append(opt);
		}

		for (i=minAxis;i<=maxAxis;i++)
		{
			var opt = "<option value='"+i+"'>"+i+"</option>"
			if(i==90) opt = "<option selected value='"+i+"'>"+i+"</option>";
			$('#userSetAxis').append(opt);
			$('#userSetAxis-BVD').append(opt);
		}

		
		$('#userSetSpherical').change(function() {
			data.ToricModel.spectacleRefraction = new RefractionData(Number($('#userSetSpherical').val()),Number($('#userSetCylindrical').val()),Number($('#userSetAxis').val()))
			app.toric.calculateTrialLensValue(data.ToricModel.spectacleRefraction);
	        app.toric.calculateOrderLensValue(data.ToricModel.spectacleRefraction);
		});
		
		$('#userSetCylindrical').change(function() {
			data.ToricModel.spectacleRefraction = new RefractionData(Number($('#userSetSpherical').val()),Number($('#userSetCylindrical').val()),Number($('#userSetAxis').val()))
			app.toric.calculateTrialLensValue(data.ToricModel.spectacleRefraction);
	        app.toric.calculateOrderLensValue(data.ToricModel.spectacleRefraction);
		});
		
		$('#userSetAxis').change(function() {
			data.ToricModel.spectacleRefraction = new RefractionData(Number($('#userSetSpherical').val()),Number($('#userSetCylindrical').val()),Number($('#userSetAxis').val()))
			app.toric.calculateTrialLensValue(data.ToricModel.spectacleRefraction);
	        app.toric.calculateOrderLensValue(data.ToricModel.spectacleRefraction);
		});
		
		
		$('#userSetSpherical-BVD').change(function() {
			app.BVDCalc.updateResult();
		});
		
		$('#userSetCylindrical-BVD').change(function() {
			app.BVDCalc.updateResult();
		});
		
		$('#userSetAxis-BVD').change(function() {
			app.BVDCalc.updateResult();
		});
		
		
		$('#control').knobKnob({
			snap : 10,
			value: 0,
			turn : function(ratio){
				app.toric.displayValueFromRatio(ratio);
				prevRatio = ratio
			}
			
		});


		var default_value_slider = 12;
		
		$( "#slider-backvertex").slider(
		{
			range: "min",
			min: 5,
			max: 20,
			value: default_value_slider,
			slide: function( event, ui )
			{
				$("#slider-backvertex-value").html(ui.value+"mm");
				$('#slider-backvertex-value').attr("data-value", ui.value);
				
				//toricCalc.updateResult();
				data.ToricModel.userBVD = ui.value;
				app.toric.calculateOrderLensValue(data.ToricModel.spectacleRefraction);
			}
		});
		$("#slider-backvertex-value").html(default_value_slider+"mm");
		$('#slider-backvertex-value').attr("data-value", default_value_slider);

		
		$( "#slider-backvertex-BVD").slider(
		{
			range: "min",
			min: 5,
			max: 20,
			value: default_value_slider,
			slide: function( event, ui )
			{
				$("#slider-backvertex-value-BVD").html(ui.value+"mm");
				$('#slider-backvertex-value-BVD').attr("data-value", ui.value);
				
				app.BVDCalc.updateResult();
			}
		});
		$("#slider-backvertex-value-BVD").html(default_value_slider+"mm");
		$('#slider-backvertex-value-BVD').attr("data-value", default_value_slider);

		
		$( "#eyeIncrementButton" )
	      .click(function( event ) {
	        event.preventDefault();
			$('#control').knobKnob.incrementRotation();
			if (typeof app.BVDCalc.updateResult === 'function')
			{
				app.BVDCalc.updateResult();
			}
	    });
		$( "#eyeDecrementButton" )
	      .click(function( event ) {
	        event.preventDefault();
			$('#control').knobKnob.decrementRotation();
			if (typeof app.BVDCalc.updateResult === 'function')
			{
				app.BVDCalc.updateResult();
			}
	      });
		  
		//probably don't need these
		//For Order result labels
		
		var pvtLbl = $('label#pvtLbl');
		var pvtLbl2 = $('label#pvtLbl2');
		var sltLbl = $('label#sltLbl');
		var slddLbl = $('div#slddLbl')
		
		//For Order result divs
		var pvtFO = $('div#pvtFO')
		var sltFO = $('div#sltFO')
		var slddFO = $('div#slddFO')
		
		
		
		$('#preloader').hide()
		
		$("#toric-area").fadeIn();
		
	},

	calculateOrderLensValue: function(arg1)
	{
		/* 
		arg1 = RefractionData
		*/
		var theoLbl = $('label#theoLbl');
		var vbCont = $('div#vbCont');
			
		this.errorPrompt = $('div#errorPrompt')

		vbCont.empty()
		
		var loc1=null;
		var loc2=null;
		var loc4=0;
		var loc5=null;
		var loc6=null;
		var loc7=null;
		var loc8=null;
		var loc3=false;
		
		// console.log("calculateOrderLensValue: ");
		// console.log("data.ToricModel.selectedLens: "+data.ToricModel.selectedLens);
		// console.log("data.ToricModel.userAxisAngle: "+data.ToricModel.userAxisAngle);
		// console.log("data.ToricModel.userBVD: "+data.ToricModel.userBVD);
		
		if (typeof app.ToricCalc.getAllLensDataSets !== 'function')
		{
			alert('Cannot use get all lens data sets');
			return true;
		}
		loc1 = app.ToricCalc.getAllLensDataSets(arg1, data.ToricModel.selectedLens, data.ToricModel.userAxisAngle, data.ToricModel.userBVD, true);
		if (loc1.length > 0) 
		{
			loc3 = true;
			loc4 = 0;
				
			while (loc4 < loc1.length) 
			{
				if (loc1[loc4].data != null) 
				{
					var htmlListNode = "<div class='resultsList'><h4>"+loc1[loc4].label+"</h4><label>" + app.toric.dataLabel(loc1[loc4].data) + "</label></div>"
					// console.log("calculateOrderLensValue label: "+loc1[loc4].label);
					// console.log("calculateOrderLensValue data.axis: "+(loc1[loc4].data.axis));
				  	vbCont.append(htmlListNode)
					loc3 = false;
				}
				++loc4;
			}
		} else {
			loc3 = true;
		}

		if (loc3) 
		{
			/*
			this.orderLensContainer.removeAllElements();
			(loc8 = new spark.components.Label()).styleName = "lensResultValue";
			loc8.text = data.InterfaceData.error;
			this.orderLensContainer.addElement(loc8);
			*/
			var htmlListNode = "<div class='resultsList'><h4>"+data.RawLensData.to_ERROR+"</h4></div>"

			vbCont.append(htmlListNode)
			// console.log("add error");
		}
		// console.log('data.ToricModel.userAxisAngle: '+data.ToricModel.userAxisAngle)
		loc2 = app.ToricCalc.getTheoreticalValues(arg1, data.ToricModel.userAxisAngle, data.ToricModel.userBVD);
		// console.log("theoretical values: "+loc2.spher + " / " + loc2.cyl + " x " + loc2.axis);
		theoLbl.html(app.toric.dataLabel(loc2));
		theoLbl.css("opacity", 1);
		return;
	},

	dataLabel: function(arg1)
	{
		return arg1.spher.toFixed(2) + " / " + arg1.cyl.toFixed(2) + " x " + arg1.axis	;
	},

	calculateTrialLensValue: function(arg1)
	{
		/*
		arg1 = refraction data
		*/

		
		var vbRTCont = $('div#vbRtCont');
		vbRTCont.empty()
		
		var loc1=null;
		var showTheoreticalPower=false;
		var loc3=0;
		var loc4=null;
		var loc5=null;
		var loc6=null;
		var loc7=null;
		var loc8=null;
		var loc9=null;

		if (typeof app.ToricCalc.getAllLensDataSets !== 'function')
		{
			alert('Cannot call method on toricCal');
			return false;
		}
		loc1 = app.ToricCalc.getAllLensDataSets(arg1, data.ToricModel.selectedLens, data.RawLensData.DEFAULT_ANGLE, data.RawLensData.DEFAULT_BVD,false);
		if (loc1.length > 0 && loc1[0].data != null) 
		{
			// console.log('DO NOT SHOW theoretical power ('+loc1.length+')')
			showTheoreticalPower = false;
			loc3 = 0;
			while (loc3 < loc1.length) 
			{
				if (loc1[loc3].data != null) 
				{
					var htmlListNode = "<div class='resultsList'><h4>"+loc1[loc3].label+"</h4><label>" + app.toric.dataLabel(loc1[loc3].data) + "</label></div>"

					
					vbRTCont.append(htmlListNode)
				}
				++loc3;
			}
			this.lastError = "";
		}
		else 
		{
			// console.log('SHOW theoretical power ('+loc1.length+')')
			showTheoreticalPower = true;
			
			
		}
		if (showTheoreticalPower==true) 
		{
			loc7 = app.ToricCalc.getTheoreticalValues(arg1, data.RawLensData.DEFAULT_ANGLE, data.RawLensData.DEFAULT_BVD);
			// console.log('DSAF')
			var htmlListNode = "<div class='resultsList'><h4>"+data.RawLensData.to_THEORETICAL_POWER+"</h4><label>" + app.toric.dataLabel(loc7) + "</label></div>"

			vbRTCont.append(htmlListNode)
			// console.log(loc7);
		}
		return;
	},

	displayValueFromRatio: function(ratio)
	{
		var adjRatio = ratio
		var degrees = 0
		
		if(ratio>=0.5){
			adjRatio = (ratio-1)
			degrees = Math.floor((360)*adjRatio)
		}else{
			adjRatio = ratio*2
			degrees = Math.floor((180)*adjRatio)	
		}
		
		//console.log("adjRatio: "+adjRatio);
		//console.log("degrees: "+degrees);
		
		$('#eyeSpinnyValue label').html(Math.abs(degrees)+"&deg;")
		$('#eyeSpinnyValue label').attr("data-value", degrees)
		
		data.ToricModel.userAxisAngle = degrees;
		if (typeof app.toric.calculateOrderLensValue === 'function'){
			app.toric.calculateOrderLensValue(data.ToricModel.spectacleRefraction);	
		} else {
			alert('cannot call');
		}
		
			
	},

	populateLanguageLabels: function(xml)
	{
		
		/*
		go through every node of the xml, find the matching data-langlabel
		*/
		
		var errorLabelName = "to_error"
		var theoreticalLabelName = "to_theoreticalpower"
		
		var arrDataLabels = [
			"to_DEFAULT",
			"to_ERROR",
			"to_THEORETICAL_POWER",
			"to_LENS_LABEL_SOFLENS_DAILY_MULTILINE",
			"to_LENS_LABEL_SOFLENS_DAILY", 
			"to_LENS_LABEL_SOFLENS_DAILY_MULTILINE",
			"to_LENS_LABEL_SOFLENS_DAILY",
			"to_LENS_LABEL_SOFLENS",
			"to_LENS_LABEL_PURE_2HD_MULTILINE",
			"to_LENS_LABEL_PURE_2HD",
			"TO_LENS_LABEL_PURE"
		]

		$(xml).find('lens_calculator').children().each(function(index){
			
			var labelID = this.nodeName;
			var label = $(this).text();

			//console.log(label);


			$('*[data-langlabel="'+labelID+'"]').html(label);
			
			$(this).children().each(function(index){
				labelID = this.nodeName;
				label = $(this).text();
				//console.log("----"+labelID);
			//console.log(label);
				$('*[data-langlabel="'+labelID+'"]').html(label);
				
				
				$.inArray( labelID, arrDataLabels )
				
				if($.inArray( labelID, arrDataLabels )!=-1){
					data.RawLensData[labelID] = label;
				}
			})
		});
	}		
}


/**
 * Use toric calculator object
 * 
 * @param  {[type]} e [description]
 * @return {[type]}   [description]
 */
$(document).ready(function(e) {

		var local = true;

		if(local) {
			var xml = '<?xml version="1.0" encoding="utf-8"?><lens_calculator language="en"><title><![CDATA[Lens Calculator]]></title><!-- Shared Data --><lens_names><sdd_lens><![CDATA[SofLens® daily disposable Toric]]></sdd_lens><slt_lens><![CDATA[SofLens® For Astigmatism]]></slt_lens><pvt_lens><![CDATA[PureVision® For Astigmatism]]></pvt_lens> </lens_names><!-- shortened to ssr --><set_spec_refrac><ssr_head><![CDATA[<span>1.</span> Set Spectacle Refraction]]></ssr_head><ssr_sphere_label><![CDATA[Sphere]]></ssr_sphere_label><ssr_cyl_label><![CDATA[Cyl]]></ssr_cyl_label><ssr_axis_label><![CDATA[Axis]]></ssr_axis_label> </set_spec_refrac><!-- Shared Data END --><!-- shortened to to --><toric_state><to_title><![CDATA[Toric]]></to_title><to_rec_trial_lens_head><![CDATA[Recommended Trial Lens]]></to_rec_trial_lens_head><to_adjust_lens_rot_head><![CDATA[<span>2.</span> Adjust Lens Rotation]]></to_adjust_lens_rot_head><to_adjust_lens_rot_units><![CDATA[Units:]]></to_adjust_lens_rot_units><to_ab_head><![CDATA[<span>3.</span> Adjust Back Vertex Distance]]></to_ab_head><lfo_head><![CDATA[Results: Lens for Order]]></lfo_head><lfo_sub_head><![CDATA[For order:]]></lfo_sub_head><ctp_head><![CDATA[Calculated Theoretical Power]]></ctp_head><ctp_sub_head><![CDATA[at the corneal plane]]></ctp_sub_head><to_DEFAULT><![CDATA[Select a Specatacle Refraction]]></to_DEFAULT><to_ERROR><![CDATA[Please use the theoretical calculated power for an alternative lens choice]]></to_ERROR><to_THEORETICAL_POWER><![CDATA[Theoretical Power]]></to_THEORETICAL_POWER><to_LENS_LABEL_SOFLENS_DAILY_MULTILINE><![CDATA[SofLens®\ndaily disposable toric]]></to_LENS_LABEL_SOFLENS_DAILY_MULTILINE><to_LENS_LABEL_SOFLENS_DAILY><![CDATA[SofLens® daily disposable toric]]></to_LENS_LABEL_SOFLENS_DAILY><to_LENS_LABEL_SOFLENS><![CDATA[SofLens® Toric]]></to_LENS_LABEL_SOFLENS><to_LENS_LABEL_PURE_2HD_MULTILINE><![CDATA[PureVision®2 HD\nfor Astigmatism]]></to_LENS_LABEL_PURE_2HD_MULTILINE><to_LENS_LABEL_PURE_2HD><![CDATA[PureVision®2 HD for Astigmatism]]></to_LENS_LABEL_PURE_2HD><to_LENS_LABEL_PURE><![CDATA[Biotrue®ONEday for Astigmatism]]></to_LENS_LABEL_PURE></toric_state><!-- shortened to in --><bvd_state><bvd_title><![CDATA[Back Vertex Distance]]></bvd_title><bvd_result_head><![CDATA[Result: Ocular Refraction]]></bvd_result_head><bvd_ab_head><![CDATA[2. Adjust Back Vertex Distance]]></bvd_ab_head> </bvd_state><!-- shortened to in --><information_state><in_title><![CDATA[Information]]></in_title><in_body_text_1><![CDATA[<p>To use this toric calculator tool provide the application with the spectacle refraction and entering the sphere, cylinder and axis details.</p><br/><p>You can adjust the back vertex distance of this refraction on the tool if required.</p><br/><p>The application will then provide the recommended lens of first choice for your selected Bausch & Lomb brand and calculated theoretical power should you choose to use an alternative. If the spectacle refraction is outside the range of the available Bausch & Lomb lenses, the theoretical lens power is shown and this can be used as a basis for your lens choice.</p>]]></in_body_text_1><in_body_text_2><![CDATA[<p>Once a lens has been placed on the eye, you can indicate the rotation of the lens on the screen by either rotating the eye/lens image with your mouse or move the up and down arrows to enter the precise rotation value. We suggest that this is measured on the slit lamp by using a narrow beam and using the beam-rotation facility to match the central scribe mark location of the lens with the slit beam.</p><br/><p>After entering the lens rotation value, the suggested lens for order for your brand of choice is shown in the bottom of the screen. This lens is predicted to offer the best lens fit and visual performance for your patient.</p>]]></in_body_text_2><in_disclaimer><![CDATA[<p><b>Disclaimer:</b> The toric lens tool is designed to provide a starting point for toric lens selection and modification. Final prescription should be detemined by your normal toric lens fitting practices.</p>]]></in_disclaimer><in_dev_by><![CDATA[<p>Developed by <a href="http://www.tinopolisinteractive.com" target="_blank">Tinopolis Interactive</a>.</p><p>© 2010 Bausch & Lomb Incorporated. ®/™ denote trademarks of Bausch & Lomb Incorporated. Other products /brand names are trademarks of their respective owners.</p>]]></in_dev_by> </information_state></lens_calculator>';
			var xmlDoc = $.parseXML(xml);
			app.toric.populateLanguageLabels(xmlDoc);
			app.ToricCalc.init();
			app.toric.init();	
			app.BVDCalc.init(); 
		} else {
			$.ajax({
		    type: "GET",
				url: "js/toric_language-en.xml",
		       dataType: "xml",
		    	success: function(xml){
					app.toric.populateLanguageLabels(xml);
					app.ToricCalc.init();
					app.toric.init();	
					app.BVDCalc.init();
				}
			});			
		}

});


       
